import { api } from './axios'

export type HardDeleteStatus = 'pending' | 'approved' | 'rejected' | 'all'
export type HardDeleteEntityType =
  | 'school'
  | 'teacher'
  | 'master_data'
  | 'non_teaching_staff'
  | 'edu_qual'
  | 'all'

export interface HardDeleteRequest {
  id: number
  entity_type: 'school' | 'teacher' | 'master_data' | 'non_teaching_staff' | 'edu_qual'
  school_id?: string | null
  school_db_id?: number | null
  school_name?: string | null
  teacher_db_id?: number | null
  teacher_name?: string | null
  teacher_ID?: string | null
  master_entity_type?: string | null
  master_entity_id?: number | null
  master_entity_name?: string | null
  non_teaching_staff_db_id?: number | null
  non_teaching_staff_name?: string | null
  requested_by_id: number
  requested_by?: { id: number; username: string; email: string | null; role: string }
  approved_by_id?: number | null
  approved_by?: { id: number; username: string; email: string | null } | null
  reason: string
  status: string
  created_at: string
  approved_at?: string | null
  executed_at?: string | null
  rejected_at?: string | null
  rejection_remarks?: string | null
}

export interface HardDeleteListResponse {
  success: boolean
  message: string
  data: HardDeleteRequest[]
  total: number
  page: number
  limit: number
}

export const hardDeleteRequestsApi = {
  list: (params?: { status?: HardDeleteStatus; entityType?: HardDeleteEntityType; page?: number; limit?: number }) =>
    api.get<HardDeleteListResponse>('/hard-delete-requests', { params }),

  create: (body: { entity_type: 'master_data'; master_entity_type: string; master_entity_id: number; master_entity_name?: string; reason: string }) =>
    api.post<{ success: boolean; message: string; data?: { id: number } }>('/hard-delete-requests', body),

  approve: (id: number, approvalRemarks: string) =>
    api.post<{ success: boolean; message: string }>(`/hard-delete-requests/${id}/approve`, {
      approval_remarks: approvalRemarks.trim(),
    }),

  reject: (id: number, rejectionRemarks?: string) =>
    api.post<{ success: boolean; message: string }>(`/hard-delete-requests/${id}/reject`, {
      rejection_remarks: rejectionRemarks
    })
}
